import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickStats = ({ className = '' }) => {
  const stats = [
    {
      label: 'Active Listings',
      value: '2,847',
      change: '+12%',
      changeType: 'positive',
      icon: 'Package',
      description: 'Cranes currently for sale'
    },
    {
      label: 'Avg. Market Time',
      value: '67 days',
      change: '-8%',
      changeType: 'positive',
      icon: 'Clock',
      description: 'Average days on market'
    },
    {
      label: 'Price Trend',
      value: '+2.3%',
      change: 'vs last month',
      changeType: 'positive',
      icon: 'TrendingUp',
      description: 'Market value movement'
    },
    {
      label: 'New This Week',
      value: '143',
      change: '+23%',
      changeType: 'positive',
      icon: 'Plus',
      description: 'Fresh inventory added'
    }
  ];

  const getChangeColor = (type) => {
    return type === 'positive' ? 'text-success' : 'text-error';
  };

  return (
    <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 ${className}`}>
      {stats?.map((stat, index) => (
        <div key={index} className="bg-surface border border-border rounded-lg shadow-card p-4 hover:shadow-modal transition-smooth">
          <div className="flex items-center justify-between mb-3">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name={stat?.icon} size={20} className="text-primary" />
            </div>
            <div className={`text-sm font-medium ${getChangeColor(stat?.changeType)}`}>
              {stat?.change}
            </div>
          </div>
          
          <div className="space-y-1">
            <div className="text-2xl font-bold text-text-primary">
              {stat?.value}
            </div>
            <div className="text-sm font-medium text-text-primary">
              {stat?.label}
            </div>
            <div className="text-xs text-text-secondary">
              {stat?.description}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default QuickStats;